
import {
  MEASURE_IDS,
  CLASSIFICATIONS_LEARN,
  CLASSIFICATIONS_ACT,
  CLASSIFICATIONS_SOCIAL,
  CLASSIFICATIONS_REACH,
  CLASSIFICATIONS_CAPACITY
} from '../../constants'; 

export const STAGES = {
  Learn: 1,
  Act: 2,
  SocialImpact: 3,
  Reach: 5,
  CapacityDevelopment: 6
};

const getResult = (indId, results) => {
  const inResults = results?.filter(res => res.indicatorId === indId)?.[0];
  if (inResults) {
    return {
      resultId: inResults?.dbId,
      forecast: inResults?.forecastCurrent??0,
      description: inResults?.description??'',
      classification: inResults?.classification??'',
      tracking: inResults?.attachment,
      fileId: inResults?.attachmentId
    };
  }
  return { resultId: null, forecast: 0 };
};

export const getResults = (report, indicators) => {
  const results = report?.results;
    return {
      1: indicators?.filter(({stageId}) => stageId===1).map(item => ({...item, ...getResult(item.dbId, results) })),
      2: indicators?.filter(({stageId}) => stageId===2).map(item => ({...item, ...getResult(item.dbId, results) })),
      3: indicators?.filter(({stageId}) => stageId===3).map(item => ({...item, ...getResult(item.dbId, results) })),
      5: indicators?.filter(({stageId}) => stageId===5).map(item => ({...item, ...getResult(item.dbId, results) })),
      6: indicators?.filter(({stageId}) => stageId===6).map(item => ({...item, ...getResult(item.dbId, results) })),
    };
};

const getOpts = (acc, row) => {
  row.ids[0].list.forEach(id => {
    acc.push({
      value: id,
      label: `(${row.label}) ${MEASURE_IDS[id]}`
    });
  });
  return acc;
};

export const OPT_CLASS_LEARN = CLASSIFICATIONS_LEARN.reduce(getOpts, []);
export const OPT_CLASS_ACT = CLASSIFICATIONS_ACT.reduce(getOpts, []);
export const OPT_CLASS_SOCIAL = CLASSIFICATIONS_SOCIAL.reduce(getOpts, []);
export const OPT_CLASS_REACH = CLASSIFICATIONS_REACH.reduce(getOpts, []);
export const OPT_CLASS_CAPACITY = CLASSIFICATIONS_CAPACITY.reduce(getOpts, []);
